import { __awaiter } from "tslib";
import _ from 'lodash';
import { refreshIndexes, createDraggingItemsShell, typeBackendAnswer, setLeveragesStamp, getLeveragesStamp, getLeverageFromStampById, LeveragesErrors } from '@/components/pages/leveragesPage/helpers';
import { declOfNum } from '@/utils/numbers';
import services from '@/services';
const dropGhost = {
    index: 0,
    item: null
};
let itemsQuantity = 0;
let LEVERAGES_BOX_REF = null;
let DRAG_PREVIEW_REF = null;
let CONTAINER_BOX_REF = null;
let CONTAINER_BOX_PARENT_REF = null;
let DROP_PREVIEW_REF = null;
let leftMouseButtonIsDown = false;
const leverageErrorHandler = (vm, leverages) => {
    let title = 'Плечо не изменено';
    let content = '';
    leverages.forEach((leverage) => {
        const { symbol } = leverage;
        if (leverage.error) {
            switch (leverage.error) {
                case LeveragesErrors.INVALID_LEVERAGE:
                    content = 'Введённое значение плеча выходит за допустимые пределы для этого инструмента.';
                    break;
                case LeveragesErrors.THERE_EXISTS_OPEN_ORDERS:
                    title = 'Маржа не изменена';
                    content = `Не удалось изменить маржу ${symbol}: есть открытая позиция или выставлены заявки по этому инструменту. Закройте их и попробуйте снова.`;
                    break;
                case LeveragesErrors.THERE_EXISTS_QUANTITY:
                    title = 'Маржа не изменена';
                    content = `Не удалось изменить маржу ${symbol}: есть открытая позиция или выставлены заявки по этому инструменту. Закройте их и попробуйте снова.`;
                    break;
                case LeveragesErrors.ISOLATED_LEVERAGE_REJECT_WITH_POSITION:
                    content = `Не удалось снизить плечо ${symbol}: на этом инструменте установлена изолированная маржа и есть открытая позиция. Закройте позицию и попробуйте изменить плечо снова.`;
                    break;
                case LeveragesErrors.SYMBOL_ALREADY_CLOSED:
                    title = `${symbol} не поддерживается`;
                    content = `Инструмент ${symbol} ограничен биржей Binance. На данный момент он недоступен для торговли и изменения настроек.`;
                    break;
                case LeveragesErrors.JOINT_MARGIN_REJECT_WITH_ISOLATED:
                    title = 'Маржа не изменена';
                    content = 'Не удалось изменить маржу на изолированную, так как включён режим мультиактивов. Выключите режим и попробуйте изменить маржу снова.';
                    break;
            }
            vm.$store.dispatch('alertsBus/openAlert', {
                title,
                type: 'error',
                autoDelete: true,
                content
            });
        }
    });
};
function changeLeverages(vm, payload, isCancel = false) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield vm.services.mainService.setLeveragesValue({ items: payload });
        if (response.success) {
            const baseListStamp = getLeveragesStamp();
            setLeveragesStamp(vm.baseList);
            if (isCancel) {
                vm.$store.dispatch('alertsBus/openAlert', {
                    title: vm.$t('leveragesPage.alerts.titles.operationCancel'),
                    type: 'info',
                    autoDelete: true,
                    content: ''
                });
                return;
            }
            vm.$store.dispatch('alertsBus/openAlert', {
                title: 'Успешно',
                type: 'success',
                autoDelete: true,
                content: 'Значение плеча изменено',
                action: {
                    text: 'Отменить',
                    callback: () => {
                        const payloadToCancel = payload.map((item) => ({
                            id: item.id,
                            value: getLeverageFromStampById(baseListStamp, item.id).val
                        }));
                        changeLeverages(vm, payloadToCancel, true);
                        vm.baseList = baseListStamp;
                    }
                }
            });
        }
        else {
            let errorContent = [];
            if ('leverages' in response.data) {
                const leverages = response.data.leverages;
                leverageErrorHandler(vm, leverages);
            }
            else if ('errors' in response.data) {
                errorContent = response.data.errors;
            }
            else {
                errorContent = [this.$t('leveragesPage.alerts.content.failedToChangeLeveragesValue')];
            }
            errorContent.forEach(error => {
                vm.$store.dispatch('alertsBus/openAlert', {
                    title: vm.$t('leveragesPage.alerts.titles.error'),
                    type: 'error',
                    autoDelete: true,
                    content: error
                });
            });
            if (getLeveragesStamp()) {
                const baseListStamp = getLeveragesStamp();
                for (const leverage of payload) {
                    const currentLeverageStamp = getLeverageFromStampById(baseListStamp, leverage.id);
                    vm.baseList[currentLeverageStamp.folderIndex].items[currentLeverageStamp.index].val = currentLeverageStamp.val;
                }
            }
        }
    });
}
function chenageLeveragesMarginType(vm, leverage, value, isCancel = false) {
    var _a;
    return __awaiter(this, void 0, void 0, function* () {
        vm.changeMarginTypeLoader = true;
        const payload = {
            items: [
                { id: leverage.id, marginType: value === 0 ? 'crossed' : 'isolated' }
            ]
        };
        const response = yield vm.services.mainService.setLeverageMarginType(payload);
        const baseListStamp = getLeveragesStamp();
        const leverageStamp = (baseListStamp ? getLeverageFromStampById(baseListStamp, leverage.id) : null);
        if (response.success) {
            if (isCancel) {
                vm.$store.dispatch('alertsBus/openAlert', {
                    title: vm.$t('leveragesPage.alerts.titles.operationCancel'),
                    type: 'info',
                    autoDelete: true,
                    content: ''
                });
            }
            else {
                vm.$store.dispatch('alertsBus/openAlert', {
                    title: vm.$t('leveragesPage.alerts.titles.success'),
                    type: 'success',
                    autoDelete: true,
                    content: vm.$t('leveragesPage.alerts.content.marginTypeChanged'),
                    action: {
                        text: 'Отменить',
                        callback: () => {
                            debouncedChangeMarginType(vm, leverage, leverageStamp.marginType, true);
                        }
                    }
                });
            }
            vm.temporaryEditableInAsideLeverage.marginType = value;
            vm.baseList[leverage.folderIndex].items[leverage.index].marginType = value;
            setLeveragesStamp(vm.baseList);
        }
        else {
            yield vm.$store.dispatch('mainPageModules/loadFuturesData', true);
            if ((_a = response.data) === null || _a === void 0 ? void 0 : _a.leverages) {
                leverageErrorHandler(vm, response.data.leverages);
            }
            else {
                vm.$store.dispatch('alertsBus/openAlert', {
                    title: vm.$t('leveragesPage.alerts.titles.error'),
                    type: 'error',
                    autoDelete: true,
                    content: vm.$t('leveragesPage.alerts.content.marginTypeChangeFailed')
                });
            }
            if (baseListStamp && leverageStamp) {
                vm.temporaryEditableInAsideLeverage.marginType = leverageStamp.marginType;
                vm.baseList[leverage.folderIndex].items[leverage.index].marginType = leverageStamp.marginType;
            }
        }
        vm.changeMarginTypeLoader = false;
    });
}
const debouncedByIdChangeLeverage = new Map();
const debouncedChangeLeverages = _.debounce(changeLeverages, 500);
const debouncedChangeMarginType = _.debounce(chenageLeveragesMarginType, 50);
function tryApplyNewLeveragesValue(payload, isCancel = false) {
    var _a;
    return __awaiter(this, void 0, void 0, function* () {
        setLeveragesStamp(this.baseList);
        const response = yield this.services.mainService.setLeveragesValue({ items: payload });
        if (response.success) {
            if (isCancel) {
                this.$store.dispatch('alertsBus/openAlert', {
                    title: 'Операция отменена',
                    type: 'info',
                    autoDelete: true,
                    content: ''
                });
            }
            else {
                this.$store.dispatch('alertsBus/openAlert', {
                    title: 'Успешно',
                    type: 'success',
                    autoDelete: true,
                    content: `Плечи выбранных тикеров изменены на “${payload[0].value}”`,
                    action: {
                        text: 'Отменить',
                        callback: () => {
                            const baseListStamp = getLeveragesStamp();
                            const payloadToCancel = payload.map((item) => ({
                                id: item.id,
                                value: getLeverageFromStampById(baseListStamp, item.id).val
                            }));
                            debouncedTryApplyNewLeveragesValue.call(this, payloadToCancel, true);
                        }
                    }
                });
            }
            this.handleMassChangeLeveragesValue(payload);
        }
        else {
            if ((_a = response.data) === null || _a === void 0 ? void 0 : _a.leverages) {
                const leverages = response.data.leverages;
                const hasSuccessChanged = leverages.some((leverage) => leverage.success);
                if (hasSuccessChanged) {
                    this.$store.dispatch('alertsBus/openAlert', {
                        title: 'Успешно',
                        type: 'success',
                        autoDelete: true,
                        content: `Плечи выбранных тикеров изменены на “${payload[0].value}”`
                    });
                }
                leverageErrorHandler(this, leverages);
                const successChangesLeverages = leverages.filter((leverage) => leverage.success).map((leverage) => ({
                    id: leverage.id,
                    value: leverage.val
                }));
                this.handleMassChangeLeveragesValue(successChangesLeverages);
            }
            else {
                this.$store.dispatch('alertsBus/openAlert', {
                    title: 'Ошибка',
                    type: 'error',
                    autoDelete: true,
                    content: 'Не удалось изменить значение выбранных тикеров'
                });
            }
        }
    });
}
const debouncedTryApplyNewLeveragesValue = _.debounce(tryApplyNewLeveragesValue, 1000, { leading: false });
function tryApplyNewMarginType(payload, isCancel = false) {
    var _a;
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield this.services.mainService.setLeverageMarginType({ items: payload });
        if (response.success) {
            if (isCancel) {
                this.$store.dispatch('alertsBus/openAlert', {
                    title: 'Операция отменена',
                    type: 'info',
                    autoDelete: true,
                    content: ''
                });
            }
            else {
                this.$store.dispatch('alertsBus/openAlert', {
                    title: 'Успешно',
                    type: 'success',
                    autoDelete: true,
                    content: `Маржа выбранных тикеров изменена на “${payload[0].marginType === 'crossed' ? 'Кросс' : 'Изолированная'}”`,
                    action: {
                        text: 'Отменить',
                        callback: () => {
                            const baseListStamp = getLeveragesStamp();
                            const payloadToCancel = payload.map((item) => ({
                                id: item.id,
                                marginType: getLeverageFromStampById(baseListStamp, item.id).marginType === 0 ? 'crossed' : 'isolated'
                            }));
                            throttledTryApplyNewMarginType.call(this, payloadToCancel, true);
                        }
                    }
                });
            }
            this.handleMassChangeLeveragesMarginType(payload);
        }
        else {
            if ((_a = response.data) === null || _a === void 0 ? void 0 : _a.leverages) {
                const leverages = response.data.leverages;
                const hasSuccessChanged = leverages.some((leverage) => leverage.success);
                if (hasSuccessChanged) {
                    this.$store.dispatch('alertsBus/openAlert', {
                        title: 'Успешно',
                        type: 'success',
                        autoDelete: true,
                        content: `Маржа выбранных тикеров изменена на “${payload[0].marginType === 'crossed' ? 'Кросс' : 'Изолированная'}”`
                    });
                }
                leverageErrorHandler(this, response.data.leverages);
            }
            else {
                this.$store.dispatch('alertsBus/openAlert', {
                    title: 'Ошибка',
                    type: 'error',
                    autoDelete: true,
                    content: 'Не удалось изменить тип маржи для выбранных тикеров'
                });
            }
        }
    });
}
const throttledTryApplyNewMarginType = _.debounce(tryApplyNewMarginType, 1000, { leading: false });
const sendLeverageViewedChanges = (vm) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield vm.services.mainService.changeStateLeverages({
        leveragesIds: vm.tikersIds
    });
    vm.tikersIds = [];
});
const onLeverageChangesViewedDebounce = _.debounce(sendLeverageViewedChanges, 1000, { leading: false });
const lastMouseCoordinates = {
    x: 0,
    y: 0
};
export const methods = {
    getQuoteAsset(ticker) {
        const knownQuoteAssets = ['USDT', 'BTC', 'ETH', 'BNB', 'XRP', 'USDC', 'FDUSD', 'TUSD'];
        for (const asset of knownQuoteAssets) {
            if (ticker.endsWith(asset)) {
                return asset;
            }
        }
        return 'USDT';
    },
    multiAssetDisableHandler() {
        const vm = this;
        this.$store.dispatch('popupModule/openPopup', {
            type: 'confirmPopup',
            letDefaultClose: true,
            title: 'Выключение режима мультиактивов',
            slot: {
                name: 'multiAssetTogglerPopupChunk',
                data: {
                    isLoading: false
                },
                on: {
                    onDisable() {
                        return __awaiter(this, void 0, void 0, function* () {
                            vm.$store.commit('popupModule/setSlotData', { isLoading: true });
                            const response = yield services.v2.trade.removeMA();
                            yield vm.$store.dispatch('mainPageModules/loadFuturesData', true);
                            vm.$store.commit('popupModule/setSlotData', { isLoading: false });
                            const content = response.success ? 'Режим торговли изменён' : response.data.errors.join('/n');
                            const type = response.success ? 'success' : 'error';
                            vm.$store.dispatch('alertsBus/openAlert', {
                                title: vm.$t(`popups.titles.${type}`),
                                type,
                                autoDelete: true,
                                content
                            });
                            vm.$store.commit('popupModule/setClosed');
                        });
                    },
                    onCancel() {
                        vm.$store.commit('popupModule/setSlotData', { isLoading: false });
                        vm.$store.commit('popupModule/setClosed');
                    }
                }
            }
        });
    },
    handleClickMultiSelect(leverage) {
        this.isMultiSelect = true;
        this.baseList[leverage.folderIndex].items[leverage.index].selected = !leverage.selected;
        for (const folder of this.baseList) {
            this.baseList[folder.index].selected = false;
        }
    },
    onLeverageChangesViewed(leverage) {
        if (!this.tikersIds.includes(leverage.id)) {
            this.tikersIds.push(leverage.id);
            onLeverageChangesViewedDebounce(this);
        }
    },
    handleTryApplyNewLeveragesValue(payload) {
        debouncedTryApplyNewLeveragesValue.call(this, payload);
    },
    handleTryApplyNewMarginType(payload) {
        throttledTryApplyNewMarginType.call(this, payload);
    },
    handleMassChangeLeveragesValue(payload) {
        for (const item of payload) {
            const leverageInstance = getLeverageFromStampById(this.baseList, item.id);
            if (leverageInstance)
                this.baseList[leverageInstance.folderIndex].items[leverageInstance.index].val = item.value;
        }
    },
    handleMassChangeLeveragesMarginType(payload) {
        for (const item of payload) {
            const leverageInstance = getLeverageFromStampById(this.baseList, item.id);
            if (leverageInstance)
                this.baseList[leverageInstance.folderIndex].items[leverageInstance.index].marginType = item.marginType === 'crossed' ? 0 : 1;
        }
    },
    handleClickUnselectLeverage(id) {
        const vm = this;
        vm.baseList.forEach((folder) => {
            folder.items.forEach((item) => {
                if (item.id === id)
                    item.selected = false;
            });
        });
    },
    handleClickSelectAllItems() {
        this.isMultiSelect = true;
        for (const folder of this.baseList) {
            this.baseList[folder.index].selected = false;
            for (const leverage of this.baseList[folder.index].items) {
                if (!this.baseList[folder.index].items[leverage.index])
                    console.log(leverage);
                this.baseList[folder.index].items[leverage.index].selected = true;
            }
        }
    },
    handleClickUnselectAllItems() {
        this.isMultiSelect = false;
        this.baseList.forEach((folder) => {
            folder.items.forEach((item) => {
                item.selected = false;
            });
        });
    },
    handleClickOutside() {
        if (this.itemsContextMenu || this.foldersContextMenu || this.optimalLeveragesPopup)
            return;
        for (const folder of this.baseList) {
            this.baseList[folder.index].selected = false;
            for (const leverage of this.baseList[folder.index].items) {
                this.baseList[leverage.folderIndex].items[leverage.index].selected = false;
            }
        }
        this.isMultiSelect = false;
    },
    changeOptimalLeveragesPopup(val) {
        this.optimalLeveragesPopup = val;
    },
    optimalLeverageResponseHandler(errors, success) {
        if (errors.length === 0) {
            if (success.length === 1) {
                this.$store.dispatch('alertsBus/openAlert', {
                    title: 'Оптимальное плечо успешно установлено',
                    type: 'success',
                    autoDelete: true,
                    wordBreak: true,
                    content: `Инструменту ${success[0].symbol} установлено оптимальное плечо — x${success[0].value}.`
                });
            }
            else if (success.length > 1) {
                this.$store.dispatch('alertsBus/openAlert', {
                    title: 'Оптимальные плечи успешно установлены',
                    type: 'success',
                    autoDelete: true,
                    wordBreak: true,
                    content: `Выбранным ${success.length} инструментам успешно установлено оптимальное плечо.`
                });
            }
        }
        else {
            if (errors.length <= 10) {
                const names = errors.map((error) => error.symbol).join(',');
                this.$store.dispatch('alertsBus/openAlert', {
                    title: 'Изменения применены частично',
                    type: 'warning',
                    autoDelete: true,
                    wordBreak: true,
                    messages: ['<div>Не удалось установить оптимальное плечо для инструментов:</div>', `<div>${names}</div>`, '<div>Попробуйте закрыть позиции по данным инструментам и изменить плечи снова.</div>']
                });
            }
            else {
                if (success.length) {
                    this.$store.dispatch('alertsBus/openAlert', {
                        title: 'Изменения применены частично',
                        type: 'warning',
                        autoDelete: true,
                        wordBreak: true,
                        messages: [`Успешно установить оптимальное плечо удалось только для ${success.length} инструментов из ${success.length + errors.length}.`, 'Попробуйте закрыть позиции по данным инструментам и изменить плечи снова.']
                    });
                }
                else {
                    this.$store.dispatch('alertsBus/openAlert', {
                        title: 'Изменения не применены',
                        type: 'warning',
                        autoDelete: true,
                        wordBreak: true,
                        messages: ['Не удалось установить оптимальное плечо для инструментов', 'Попробуйте закрыть позиции по данным инструментам и изменить плечи снова.']
                    });
                }
            }
        }
    },
    wssOptimalLeverageHandler(leverages) {
        const wssLeverages = new WebSocket(`wss://${window.location.host}/ws/v2/exchanges/binance/leverages/`);
        wssLeverages.onopen = () => {
            wssLeverages.send(JSON.stringify({
                action: 'setupOptimalLeverage',
                tickers: leverages
            }));
        };
        wssLeverages.onerror = () => {
            this.$store.dispatch('alertsBus/openAlert', {
                title: 'Не удалось установить оптимальные плечи.',
                type: 'error',
                autoDelete: true,
                wordBreak: true,
                content: 'Произошла непредвиненная ошибка. Попробуйте снова или обратитесь в техническую поддержку.'
            });
            this.optimalLeverageLoading = false;
        };
        wssLeverages.onmessage = (event) => __awaiter(this, void 0, void 0, function* () {
            const data = JSON.parse(event.data);
            if (data.action === 'setupOptimalLeverage') {
                if (data.payload.success.length) {
                    const response = yield this.services.mainService.getLeverages(null);
                    if (response.success) {
                        const items = typeBackendAnswer(response);
                        this.baseList = items;
                        setLeveragesStamp(this.baseList);
                        this.handleResize();
                        refreshIndexes(this);
                    }
                }
                this.optimalLeverageLoading = false;
                this.optimalLeverageResponseHandler(data.payload.error, data.payload.success);
            }
        });
    },
    onOptimalLeverageSet() {
        this.optimalLeverageLoading = true;
        let leverages = [];
        if (this.selectedItems.length) {
            leverages = this.selectedItems.map((leverage) => leverage.name);
        }
        else {
            leverages = this.baseList.reduce((acc, item) => {
                return acc.concat(item.items);
            }, []).map((leverage) => leverage.name);
        }
        this.wssOptimalLeverageHandler(leverages);
    },
    preloadMaxAmount() {
        return __awaiter(this, void 0, void 0, function* () {
            const vm = this;
            const response = yield vm.services.mainService.preloadMaxLeverageAmount(null, vm.temporaryEditableInAsideLeverage.id);
            if (response.success) {
                vm.temporaryEditableInAsideLeverage.brackets = response.data.brackets.reverse().map((bracket) => ({
                    maxValue: bracket.initialLeverage,
                    maxAmount: bracket.notionalCap
                }));
            }
            else {
                vm.preloadMaxAmount();
            }
        });
    },
    handleChangeMarginType(leverage, value) {
        const vm = this;
        vm.baseList[leverage.folderIndex].items[leverage.index].marginType = value;
        debouncedChangeMarginType(vm, leverage, value);
    },
    setTemporaryLeverage() {
        const vm = this;
        const selectedItem = vm.selectedItems[0];
        const tempItem = vm.temporaryEditableInAsideLeverage;
        debouncedChangeLeverages(vm, [{ id: selectedItem.id, value: tempItem.value }]);
        selectedItem.val = tempItem.value;
    },
    toggleAsideCollapseFolder(id) {
        const vm = this;
        const findedIndex = vm.collapsedAsideFolders.findIndex((item) => item === id);
        if (findedIndex < 0) {
            vm.collapsedAsideFolders.push(id);
        }
        else
            vm.collapsedAsideFolders.splice(findedIndex, 1);
    },
    handleDragStart(event) {
        event.preventDefault();
        return false;
    },
    handleMouseDown(event, leverage) {
        let handle = true;
        leftMouseButtonIsDown = true;
        function handleSliderClick() {
            for (const child of event.path) {
                if (child.classList) {
                    if (child.classList.contains('vue-slider') || child.classList.contains('numberbox'))
                        handle = false;
                }
            }
        }
        handleSliderClick();
        if (handle) {
            const threshold = {
                x: 0,
                y: 0
            };
            if (leverage.type === 'item') {
                const vm = this;
                threshold.x = event.clientX;
                threshold.y = event.clientY;
                if (vm.selectedItems.length) {
                    DRAG_PREVIEW_REF.appendChild(createDraggingItemsShell('' + vm.selectedItems.length + ' ' + declOfNum(vm.selectedItems.length, ['тикер', 'тикера', 'тикеров'])));
                }
                else {
                    DRAG_PREVIEW_REF.appendChild(createDraggingItemsShell(leverage.name));
                }
                document.body.onmousemove = function (event) {
                    vm.asideIsOpened = false;
                    const thresolded = {
                        x: Math.abs(event.clientX - threshold.x),
                        y: Math.abs(event.clientY - threshold.y)
                    };
                    if (thresolded.x > 5 || thresolded.y > 5) {
                        vm.dragProccess = true;
                        if (!leverage.selected) {
                            if (vm.selectedItems.length) {
                                vm.selectedItems.forEach((item) => {
                                    item.selected = false;
                                });
                            }
                            leverage.selected = true;
                        }
                        DRAG_PREVIEW_REF.style.display = 'flex';
                        DRAG_PREVIEW_REF.style.transform = `translate(${event.clientX}px, ${event.clientY}px)`;
                        const parentRect = CONTAINER_BOX_REF.getBoundingClientRect();
                        if (event.pageX <= parentRect.x || (event.pageX >= parentRect.x + parentRect.width)) {
                            vm.scrollerStepDefinition.dx = 0;
                            DROP_PREVIEW_REF.style.opacity = 0;
                        }
                        else {
                            if ((event.pageX - parentRect.x) < vm.colWidth / 2) {
                                vm.scrollerStepDefinition.dx = -1 * ((vm.colWidth / 2) - (event.pageX - parentRect.x)) / 2;
                            }
                            else if ((parentRect.x + parentRect.width - event.pageX) < vm.colWidth / 2) {
                                vm.scrollerStepDefinition.dx = (vm.colWidth / 2 - (parentRect.x + parentRect.width - event.pageX)) / 2;
                            }
                            else {
                                vm.scrollerStepDefinition.dx = 0;
                            }
                        }
                    }
                };
                document.onmouseup = function () {
                    vm.scrollerStepDefinition.dx = 0;
                    leftMouseButtonIsDown = false;
                    DRAG_PREVIEW_REF.style.display = 'none';
                    DRAG_PREVIEW_REF.innerHTML = '';
                    document.body.onmousemove = null;
                    if (vm.dragProccess) {
                        vm.handleDragEnd();
                    }
                    document.onmouseup = null;
                };
            }
        }
    },
    handleManualScrollMove() {
        const vm = this;
        const parentRect = CONTAINER_BOX_REF.getBoundingClientRect();
        let hoveredElement = document.querySelectorAll(':hover');
        hoveredElement = hoveredElement[hoveredElement.length - 1];
        let parent = hoveredElement;
        let manualStopSearchingParent = false;
        while (parent && !manualStopSearchingParent) {
            if (parent.dataset.type) {
                manualStopSearchingParent = true;
            }
            else if (parent.classList.contains('leveragesBox')) {
                manualStopSearchingParent = true;
            }
            else {
                parent = parent.parentElement;
            }
        }
        if (parent) {
            const tgtOffset = parent.getBoundingClientRect();
            const diff = (lastMouseCoordinates.y - tgtOffset.top) / 40 * 100;
            if (diff > 50) {
                DROP_PREVIEW_REF.style.transform = `translate(${tgtOffset.left - parentRect.x}px, ${tgtOffset.top + parent.clientHeight - parentRect.y}px)`;
            }
            else {
                DROP_PREVIEW_REF.style.transform = `translate(${tgtOffset.left - parentRect.x}px, ${tgtOffset.top - parentRect.y}px)`;
            }
        }
    },
    handleMousemove(event, leverage) {
        lastMouseCoordinates.x = event.pageX;
        lastMouseCoordinates.y = event.pageY;
        if (this.dragProccess) {
            const findTgt = () => {
                for (const item of event.path) {
                    if (!item.dataset.type) {
                        continue;
                    }
                    else
                        return item;
                }
            };
            const tgt = findTgt();
            const parentRect = CONTAINER_BOX_REF.getBoundingClientRect();
            if (leftMouseButtonIsDown && this.dragProccess && (leverage.type === 'item' || (leverage.type === 'folder'))) {
                if (leverage.type === 'folder' && !this.baseList[leverage.index].opened) {
                    DROP_PREVIEW_REF.style.opacity = '0';
                }
                else {
                    DROP_PREVIEW_REF.style.opacity = '1';
                }
                dropGhost.item = leverage;
                const tgtOffset = tgt.getBoundingClientRect();
                const diff = (event.clientY - tgtOffset.top) / 40 * 100;
                DROP_PREVIEW_REF.style.display = 'block';
                if (diff > 50) {
                    dropGhost.index = leverage.type === 'item' ? leverage.index + 1 : 0;
                    DROP_PREVIEW_REF.style.transform = `translate(${tgtOffset.left - parentRect.x}px, ${tgtOffset.top + tgt.clientHeight - parentRect.y}px)`;
                }
                else {
                    DROP_PREVIEW_REF.style.transform = `translate(${tgtOffset.left - parentRect.x}px, ${tgtOffset.top - parentRect.y}px)`;
                    dropGhost.index = leverage.type === 'item' ? leverage.index : 0;
                }
            }
        }
    },
    toggleSelectInFolder(folderIndex) {
        const currentFolder = this.baseList[folderIndex];
        const haveUnselected = Boolean(currentFolder.items.find((item) => !item.selected));
        currentFolder.items.forEach((item) => {
            item.selected = haveUnselected;
        });
    },
    handleDragEnd() {
        return __awaiter(this, void 0, void 0, function* () {
            const vm = this;
            if (dropGhost.item) {
                const response = yield vm.services.mainService.moveLeverage({
                    items: vm.selectedItems.map((item) => item.id),
                    index: dropGhost.index
                }, dropGhost.item.type === 'item' ? dropGhost.item.folderID : dropGhost.item.id);
                if (response.success) {
                    vm.$store.dispatch('alertsBus/openAlert', {
                        title: vm.$t('leveragesPage.alerts.titles.success'),
                        type: 'success',
                        autoDelete: true,
                        content: vm.selectedItems.length > 1 ? this.$t('leveragesPage.alerts.content.tickersMoved') : this.$t('leveragesPage.alerts.content.tickerMoved')
                    });
                    const movingFolderIndex = dropGhost.item.type === 'folder' ? dropGhost.item.index : dropGhost.item.folderIndex;
                    const movingItemIndex = dropGhost.index;
                    const selectedItemsFreezedCopy = _.cloneDeep(this.selectedItems);
                    for (const leverage of selectedItemsFreezedCopy) {
                        const currentItemIndex = this.baseList[leverage.folderIndex].items.findIndex((item) => item.id === leverage.id);
                        if (currentItemIndex >= 0) {
                            const splicedLeverage = this.baseList[leverage.folderIndex].items.splice(currentItemIndex, 1)[0];
                            if (this.baseList[movingFolderIndex].items[movingItemIndex]) {
                                this.baseList[movingFolderIndex].items.splice(movingItemIndex, 0, splicedLeverage);
                            }
                            else {
                                this.baseList[movingFolderIndex].items.push(splicedLeverage);
                            }
                        }
                    }
                    refreshIndexes(this);
                    this.handleClickOutside();
                }
                else {
                    vm.$store.dispatch('alertsBus/openAlert', {
                        title: vm.$t('leveragesPage.alerts.titles.error'),
                        type: 'error',
                        autoDelete: true,
                        content: vm.selectedItems.length > 1 ? this.$t('leveragesPage.alerts.content.failedToMoveTickers') : this.$t('leveragesPage.alerts.content.failedToMoveTicker')
                    });
                }
                dropGhost.index = 0;
                dropGhost.item = null;
                DROP_PREVIEW_REF.style.display = 'none';
                this.$nextTick(() => {
                    if (this.dragProccess) {
                        vm.dragProccess = false;
                    }
                });
            }
        });
    },
    moveFolder(direction, id) {
        return __awaiter(this, void 0, void 0, function* () {
            const vm = this;
            const folderIndex = vm.baseList.findIndex((item) => item.id === id);
            if (direction === 'up') {
                const response = yield vm.services.mainService.moveLeverageFolder({
                    index: folderIndex - 1
                }, vm.baseList[folderIndex].id);
                if (response.success) {
                    vm.baseList.splice(folderIndex - 1, 0, vm.baseList.splice(folderIndex, 1)[0]);
                    vm.$store.dispatch('alertsBus/openAlert', {
                        title: vm.$t('leveragesPage.alerts.titles.success'),
                        type: 'success',
                        autoDelete: true,
                        content: this.$t('leveragesPage.alerts.content.folderMoved')
                    });
                }
                else {
                    vm.$store.dispatch('alertsBus/openAlert', {
                        title: vm.$t('leveragesPage.alerts.titles.error'),
                        type: 'error',
                        autoDelete: true,
                        content: this.$t('leveragesPage.alerts.content.folderNotMoved')
                    });
                }
            }
            else {
                const response = yield vm.services.mainService.moveLeverageFolder({
                    index: folderIndex + 1
                }, vm.baseList[folderIndex].id);
                if (response.success) {
                    vm.baseList.splice(folderIndex + 1, 0, vm.baseList.splice(folderIndex, 1)[0]);
                    vm.$store.dispatch('alertsBus/openAlert', {
                        title: vm.$t('leveragesPage.alerts.titles.success'),
                        type: 'success',
                        autoDelete: true,
                        content: this.$t('leveragesPage.alerts.content.folderMoved')
                    });
                }
                else {
                    vm.$store.dispatch('alertsBus/openAlert', {
                        title: vm.$t('leveragesPage.alerts.titles.error'),
                        type: 'error',
                        autoDelete: true,
                        content: this.$t('leveragesPage.alerts.content.folderNotMoved')
                    });
                }
            }
            vm.folderMenuInstance = null;
            vm.deleteFolderDialog = false;
            refreshIndexes(vm);
        });
    },
    openDeleteConfirm(folderID) {
        const vm = this;
        const currentFolder = this.baseList.find((folder) => folder.id === folderID);
        if (currentFolder) {
            vm.$store.dispatch('popupModule/openPopup', {
                type: 'confirmPopup',
                letDefaultClose: false,
                title: vm.$t('leveragesPage.popups.titles.acceptDelete'),
                content: vm.$t('leveragesPage.popups.content.areYouSureDeleteFolder', { name: currentFolder.name }),
                actions: [
                    {
                        title: vm.$t('leveragesPage.popups.common.dontDelete'),
                        isAccent: false,
                        callback() { vm.$store.commit('popupModule/setClosed'); }
                    },
                    {
                        title: vm.$t('leveragesPage.popups.common.delete'),
                        isAccent: true,
                        callback() {
                            vm.$store.commit('popupModule/setClosed');
                            vm.deleteFolder(currentFolder.index);
                            vm.folderMenuInstance = null;
                            vm.foldersContextMenu = false;
                        }
                    }
                ]
            });
        }
    },
    deleteFolder(folderIndex) {
        return __awaiter(this, void 0, void 0, function* () {
            const vm = this;
            const response = yield vm.services.mainService.deleteLeveragesFolder(null, this.baseList[folderIndex].id);
            vm.deleteFolderDialog = false;
            if (response.success) {
                vm.$store.dispatch('alertsBus/openAlert', {
                    title: vm.$t('leveragesPage.alerts.titles.success'),
                    type: 'success',
                    autoDelete: true,
                    content: this.$t('leveragesPage.alerts.content.folderSuccessfulMoved', { name: this.baseList[folderIndex].name })
                });
                const baseListIndexDefaultFolder = vm.baseList.findIndex((item) => item.default_folder);
                for (const item of vm.baseList[folderIndex].items) {
                    item.folderID = vm.baseList[baseListIndexDefaultFolder].id;
                }
                vm.baseList[baseListIndexDefaultFolder].items.push(...vm.baseList[folderIndex].items);
                vm.baseList.splice(folderIndex, 1);
                setTimeout(() => {
                    const baseListIndexNew = vm.baseList.findIndex((item) => item.default_folder);
                    for (const item of vm.baseList[baseListIndexNew].items) {
                    }
                    refreshIndexes(vm);
                }, 700);
            }
            else {
                vm.folderMenuInstance = null;
                vm.$store.dispatch('alertsBus/openAlert', {
                    title: vm.$t('leveragesPage.alerts.titles.error'),
                    type: 'error',
                    autoDelete: true,
                    content: this.$t('leveragesPage.alerts.content.failedTODeleteFolder')
                });
            }
        });
    },
    createFolder() {
        return __awaiter(this, void 0, void 0, function* () {
            const vm = this;
            const response = yield vm.services.mainService.createLeveragesFolder({
                name: 'Новая папка',
                locked: false,
                opened: true
            });
            if (response.success) {
                vm.baseList.unshift({
                    name: response.data.name,
                    id: response.data.id,
                    opened: response.data.opened,
                    empty: response.data.items.length < 1,
                    index: response.data.index,
                    items: response.data.items,
                    haveSelected: false,
                    default_folder: response.data.default_folder,
                    type: 'folder'
                });
                refreshIndexes(vm);
                vm.$store.dispatch('alertsBus/openAlert', {
                    title: vm.$t('leveragesPage.alerts.titles.success'),
                    type: 'success',
                    autoDelete: true,
                    content: this.$t('leveragesPage.alerts.content.folderSuccessfulCreated')
                });
            }
            else {
                vm.$store.dispatch('alertsBus/openAlert', {
                    title: vm.$t('leveragesPage.alerts.titles.error'),
                    type: 'error',
                    autoDelete: true,
                    content: this.$t('leveragesPage.alerts.content.folderCreateFailed')
                });
            }
        });
    },
    moveItem(folderIndex) {
        return __awaiter(this, void 0, void 0, function* () {
            const movingItemIndex = this.baseList[folderIndex].items.length;
            const response = yield this.services.mainService.moveLeverage({
                items: this.selectedItems.map((item) => item.id),
                index: movingItemIndex
            }, this.baseList[folderIndex].id);
            this.itemsContextMenu = false;
            if (response.success) {
                this.$store.dispatch('alertsBus/openAlert', {
                    title: this.$t('leveragesPage.alerts.titles.success'),
                    type: 'success',
                    autoDelete: true,
                    content: this.selectedItems.length > 1 ? this.$t('leveragesPage.alerts.content.tickersMoved') : this.$t('leveragesPage.alerts.content.tickerMoved')
                });
                const selectedItemsFreezedCopy = _.cloneDeep(this.selectedItems);
                for (const leverage of selectedItemsFreezedCopy) {
                    const currentItemIndex = this.baseList[leverage.folderIndex].items.findIndex((item) => item.id === leverage.id);
                    if (currentItemIndex >= 0) {
                        const splicedLeverage = this.baseList[leverage.folderIndex].items.splice(currentItemIndex, 1)[0];
                        if (this.baseList[folderIndex].items[movingItemIndex]) {
                            this.baseList[folderIndex].items.splice(movingItemIndex, 0, splicedLeverage);
                        }
                        else {
                            this.baseList[folderIndex].items.push(splicedLeverage);
                        }
                    }
                }
                refreshIndexes(this);
                this.handleClickOutside();
            }
            else {
                this.$store.dispatch('alertsBus/openAlert', {
                    title: this.$t('leveragesPage.alerts.titles.error'),
                    type: 'error',
                    autoDelete: true,
                    content: this.selectedItems.length > 1 ? this.$t('leveragesPage.alerts.content.failedToMoveTickers') : this.$t('leveragesPage.alerts.content.failedToMoveTicker')
                });
            }
        });
    },
    handleRightKeyClick(event, item) {
        const vm = this;
        vm.xCoordinate = event.clientX + 30;
        vm.yCoordinate = event.clientY;
        if (item.type === 'item')
            vm.itemsContextMenu = true;
        if (item.type === 'folder') {
            vm.folderMenuInstance = item;
            vm.foldersContextMenu = true;
        }
    },
    renameFolder(item) {
        return __awaiter(this, void 0, void 0, function* () {
            const vm = this;
            const response = yield vm.services.mainService.patchLeveragesFolder({
                name: item.name
            }, item.id);
            if (response.success) {
                vm.baseList.find((folder) => folder.id === item.id).name = item.name;
                vm.folderIDToRename = null;
                vm.$store.dispatch('alertsBus/openAlert', {
                    title: vm.$t('leveragesPage.alerts.titles.success'),
                    type: 'success',
                    autoDelete: true,
                    content: this.$t('leveragesPage.alerts.content.folderRenamed')
                });
            }
            else {
                vm.$store.dispatch('alertsBus/openAlert', {
                    title: vm.$t('leveragesPage.alerts.titles.error'),
                    type: 'error',
                    autoDelete: true,
                    content: this.$t('leveragesPage.alerts.content.folderRenameFailed')
                });
            }
        });
    },
    toggleFolderVisibility(index) {
        return __awaiter(this, void 0, void 0, function* () {
            const vm = this;
            const response = yield vm.services.mainService.patchLeveragesFolder({
                name: vm.baseList[index].name,
                opened: !vm.baseList[index].opened
            }, vm.baseList[index].id);
            if (response.success) {
                vm.baseList[index].opened = !vm.baseList[index].opened;
            }
            else {
                vm.$store.dispatch('alertsBus/openAlert', {
                    title: vm.$t('leveragesPage.alerts.titles.error'),
                    type: 'error',
                    autoDelete: true,
                    content: vm.baseList[index].opened ? this.$t('leveragesPage.alerts.content.failedToCollapseFolder') : this.$t('leveragesPage.alerts.content.failedToExpandFolder')
                });
            }
        });
    },
    handleLeverageChangeVal(leverage, value) {
        const vm = this;
        if (leverage.val > leverage.max) {
            vm.baseList[leverage.folderIndex].items[leverage.index].isChanged = false;
        }
        vm.baseList[leverage.folderIndex].items[leverage.index].val = value;
        if (leverage.id === vm.temporaryEditableInAsideLeverage.id) {
            vm.temporaryEditableInAsideLeverage.value = value;
        }
        if (!debouncedByIdChangeLeverage.has(leverage.id)) {
            debouncedByIdChangeLeverage.set(leverage.id, _.debounce(changeLeverages, 500));
        }
        debouncedByIdChangeLeverage.get(leverage.id)(vm, [{ id: leverage.id, value }]);
    },
    handleFolderClick(clickedFolder) {
        const isAllLeveragesOfFolderIsSelected = this.baseList[clickedFolder.index].items
            .every((item) => item.selected);
        if (this.miw(960)) {
            if (clickedFolder.empty) {
                this.handleClickOutside();
            }
            for (const leverageInClickedFolder of this.baseList[clickedFolder.index].items) {
                this.baseList[leverageInClickedFolder.folderIndex].items[leverageInClickedFolder.index].selected = !isAllLeveragesOfFolderIsSelected;
            }
            for (const folder of this.baseList) {
                if (folder.index !== clickedFolder.index) {
                    this.baseList[folder.index].selected = false;
                }
                else {
                    const haveAnotherFoldersSelectedItems = Boolean(this.selectedItems.find((item) => item.folderIndex !== clickedFolder.index));
                    if (haveAnotherFoldersSelectedItems) {
                        this.baseList[clickedFolder.index].selected = false;
                    }
                    else {
                        this.baseList[clickedFolder.index].selected = this.baseList[clickedFolder.index].items.length
                            ? !(isAllLeveragesOfFolderIsSelected)
                            : !this.baseList[clickedFolder.index].selected;
                    }
                }
            }
            this.isMultiSelect = Boolean(this.selectedItems.length);
        }
        else {
            for (const folder of this.baseList) {
                if (folder.id !== clickedFolder.id) {
                    this.baseList[folder.index].selected = false;
                }
                else {
                    this.baseList[folder.index].selected = !this.baseList[folder.index].selected;
                }
            }
        }
    },
    toggleSelected(itemIndex, folderIndex) {
        const vm = this;
        const currentItem = vm.baseList[folderIndex].items[itemIndex];
        this.isMultiSelect = false;
        setTimeout(() => {
            const newMargin = currentItem.marginType === 'isolated' || currentItem.marginType === 1 ? 1 : 0;
            vm.temporaryEditableInAsideLeverage.marginType = newMargin;
        }, 0);
        this.baseList[folderIndex].items[itemIndex].selected = !currentItem.selected;
        for (const folder of this.baseList) {
            this.baseList[folder.index].selected = false;
        }
        this.selectedItems.forEach((item) => {
            if (this.baseList[item.folderIndex].items[item.index].id !== currentItem.id) {
                this.baseList[item.folderIndex].items[item.index].selected = false;
            }
        });
    },
    toggleSelectedAll(value = false) {
        const vm = this;
        for (const subarr of vm.baseList) {
            for (const item of subarr.items) {
                item.selected = value;
            }
        }
    },
    handleResize() {
        const vm = this;
        vm.haveColumns = 0;
        if (vm.isInited) {
            setTimeout(() => {
                LEVERAGES_BOX_REF.style.minWidth = 'auto';
                vm.haveColumns = Math.round(LEVERAGES_BOX_REF.scrollWidth / (vm.colWidth + 20));
                LEVERAGES_BOX_REF.style.minWidth = LEVERAGES_BOX_REF.scrollWidth + 'px';
            }, 50);
        }
    },
    setCommonLeverageVal() {
        const vm = this;
        for (const item of vm.selectedItems) {
            if (item.max === vm.selectedCommonLeveragesMax) {
                item.val = vm.commonChangeLeverageValue;
                item.selected = false;
            }
        }
    },
    getMultiAssetsStatus() {
        return __awaiter(this, void 0, void 0, function* () {
            const multiAssetsStatusResponse = yield services.mainService.getMultiAssetsStatus();
            if (multiAssetsStatusResponse.success) {
                this.$store.commit('mainPageModules/setMultiAssetsStatus', multiAssetsStatusResponse.data.status);
                return;
            }
            this.isRetry = false;
            this.loadError = true;
        });
    },
    updateLeverages(updatedLeverages) {
        updatedLeverages.map((updatedLeverage) => {
            let leverageIndex = -1;
            const folderIndex = this.baseList.findIndex((folder) => {
                const hasItem = folder.items.some((folderItem, index) => {
                    if (folderItem.name === updatedLeverage.symbol) {
                        leverageIndex = index;
                    }
                    return folderItem.name === updatedLeverage.symbol;
                });
                return hasItem;
            });
            if (leverageIndex !== -1 && folderIndex !== -1) {
                this.baseList[folderIndex].items[leverageIndex].isChanged = true;
                this.baseList[folderIndex].items[leverageIndex].val = updatedLeverage.exchangeValue;
                this.baseList[folderIndex].items[leverageIndex].max = updatedLeverage.exchangeValue;
                this.baseList[folderIndex].items[leverageIndex].previousValue = updatedLeverage.previousLeverage;
            }
        });
    },
    onAutomaticLeverageChanged(val) {
        var _a, _b, _c;
        return __awaiter(this, void 0, void 0, function* () {
            if (this.automaticLeverage === val)
                return;
            this.automaticLeverage = val;
            const response = yield this.services.mainService.leverageAutoChanged({
                autoChangeLeverage: val
            });
            if (response.success) {
                if (val && ((_c = (_b = (_a = response.data) === null || _a === void 0 ? void 0 : _a.payload) === null || _b === void 0 ? void 0 : _b.updatedLeverages) === null || _c === void 0 ? void 0 : _c.length)) {
                    this.updateLeverages(response.data.payload.updatedLeverages);
                }
            }
        });
    },
    init() {
        var _a, _b, _c;
        return __awaiter(this, void 0, void 0, function* () {
            const vm = this;
            this.getMultiAssetsStatus();
            vm.isRetry = true;
            vm.loadError = false;
            CONTAINER_BOX_REF = vm.$refs.containerBox;
            CONTAINER_BOX_PARENT_REF = vm.$refs.containerBoxParent;
            LEVERAGES_BOX_REF = vm.$refs.leveragesBox;
            DRAG_PREVIEW_REF = vm.$refs.dragPreview;
            DROP_PREVIEW_REF = document.createElement('div');
            DROP_PREVIEW_REF.setAttribute('id', 'dropPreview');
            DROP_PREVIEW_REF.classList.add('leverages-drop-preview');
            CONTAINER_BOX_REF.appendChild(DROP_PREVIEW_REF);
            if (CONTAINER_BOX_REF) {
                let divider = 3;
                const ww = window.innerWidth;
                const containerHeight = CONTAINER_BOX_REF.clientHeight - 100;
                if (ww < 1904 && ww > 1264) {
                    divider = 2;
                }
                else if (ww < 1264) {
                    divider = 1;
                }
                const colWidth = Math.trunc(CONTAINER_BOX_PARENT_REF.clientWidth / divider);
                vm.colWidth = colWidth < 344 ? colWidth : 344;
                CONTAINER_BOX_REF.style.setProperty('--col-width', vm.colWidth + 'px');
                DRAG_PREVIEW_REF.style.setProperty('--col-width', vm.colWidth + 'px');
                DROP_PREVIEW_REF.style.setProperty('--col-width', vm.colWidth + 'px');
                const itemBaseHeight = 36;
                itemsQuantity = Math.floor(containerHeight / itemBaseHeight);
                const autoChangeResponse = yield vm.services.mainService.leverageAutoChange();
                if (autoChangeResponse.success) {
                    vm.automaticLeverage = (_c = (_b = (_a = autoChangeResponse === null || autoChangeResponse === void 0 ? void 0 : autoChangeResponse.data) === null || _a === void 0 ? void 0 : _a.payload) === null || _b === void 0 ? void 0 : _b.autoChangeLeverage) !== null && _c !== void 0 ? _c : false;
                }
                const response = yield vm.services.mainService.getLeverages(null);
                if (response.success) {
                    const items = typeBackendAnswer(response);
                    vm.baseList = items;
                    setLeveragesStamp(vm.baseList);
                    vm.isRetry = false;
                    vm.handleResize();
                    refreshIndexes(this);
                }
                else {
                    vm.isRetry = false;
                    vm.loadError = true;
                }
            }
        });
    }
};
